/**
 * PostHog event name constants.
 * Naming follows PostHog recommendation: snake_case, lowercase, present tense.
 */
export const PostHogEvents = {
    ACCOUNT_CREATED: `account_created`,
    ADD_PAYMENT_METHOD_CLICKED: `add_payment_method_clicked`,
    AUTOPAY_CONFIGURED: `autopay_configured`,
    AUTOPAY_TOGGLED: `autopay_toggled`,
    PASSWORD_RESET_REQUESTED: `password_reset_requested`,
    PAYMENT_CONFIRMED: `payment_confirmed`,
    PAYMENT_FAILED: `payment_failed`,
    PAYMENT_INITIATED: `payment_initiated`,
    PAYMENT_METHOD_ADDED: `payment_method_added`,
    PAYMENT_METHOD_DELETED: `payment_method_deleted`,
    USER_LOGGED_IN: `user_logged_in`
} as const;

export type PostHogEventName = (typeof PostHogEvents)[keyof typeof PostHogEvents];

/** Error type values for PAYMENT_FAILED event properties. */
export const PostHogPaymentFailedErrorType = {
    API_ERROR: `api_error`,
    PLATFORM_ERROR: `platform_error`
} as const;

export type PostHogPaymentFailedErrorTypeName =
    (typeof PostHogPaymentFailedErrorType)[keyof typeof PostHogPaymentFailedErrorType];
